<template>
    <section>
        <section class="histBtn">
            <section>
                <button @click="() => handleCollapse(true)" title="Expandir Todos"><b-icon-arrows-expand></b-icon-arrows-expand> Expandir</button>
                <button @click="() => handleCollapse(false)" title="Colapsar Todos"><b-icon-arrows-collapse></b-icon-arrows-collapse> Colapsar</button>
            </section>
            <button @click="restoreCalendarsFunc" :disabled="this.hasEquals == true" >Restaurar Calendários ({{ selectedTotals }})</button>
        </section>
        <section class="historicContainer">
            <span v-if="this.hasEquals == true" class="warningDetails">Você selecionou calendários iguais em datas diferentes.</span>
            <section v-for="(dates, idx) in localHistory" :key="idx + 'dateHist'">
                <details ref="detailsDate">
                    <summary class="summaryCalendar">{{ dates.nameGroup }}</summary>
                    <section v-for="(historyPoint, Cidx) in dates.historics" :key="Cidx + 'calendHist'"
                        class="historicCalendarContainer">
                        <b-form-checkbox v-model="historyPoint.isChecked"
                            :id="`${idx}-${Cidx}-${historyPoint.calendarId}-histPoint`" class="historicPoint">
                            <span>{{ new Date(historyPoint.dateTime).toLocaleString("pt-BR") }} - {{
                                historyPoint.calendarName }}</span>
                        </b-form-checkbox>
                    </section>
                </details>
            </section>
            <p v-if="history.length == 0">Nenhum histórico encontrado.</p>
        </section>
    </section>
</template>

<script>
export default {
    name: "CalendarHistory",
    props: ["history", "restoreCalendarsFunc"],
    data() {
        return {
            localHistory: [],
            selectedTotals: 0,
            hasEquals: false,
        }
    },
    computed: {
        checkedHistory: function () {
            let checked = [];

            this.localHistory.forEach(item => {
                item.historics.forEach(cl => {
                    if (cl.isChecked == true) checked.push(cl)
                })
            })

            return checked;
        }
    },
    watch: {
        "checkedHistory"(data) {
            const duplicateds = [];

            data.forEach((item) => {
                let found = data.filter(dt => dt.calendarId == item.calendarId || dt.calendarName == item.calendarName);
                if(found.length > 1) duplicateds.push(item);
            });

            if(duplicateds.length > 0) this.hasEquals = true;
            else this.hasEquals = false;

            this.selectedTotals = data ? data.length : 0;
        }
    },
    methods: {
        handleCollapse(status) {
            if (this.$refs.detailsDate && this.$refs.detailsDate.length > 0) {
                this.$refs.detailsDate.forEach(element => {
                    if(status == true) {element.setAttribute('open', true);}
                    else if(status == false) {element.removeAttribute('open');}
                    
                });
            }
        },
    },
    mounted() {
        this.localHistory = [...this.history];
        this.localHistory.forEach(item => {
            item.historics.forEach(cl => cl.isChecked = false);
        })
    }
}
</script>

<style scoped>
/* .summaryCalendar {
    background-color: beige;
}

.historicCalendarContainer {
    background-color: azure;
} */

.histBtn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5rem;
}

.histBtn section{
    display: flex;
    column-gap: 0.8rem;
}

.histBtn button {
    color: #ffffff;
    background-color: #33ABAB;
    font-weight: 500;
    border: 1px solid #33ABAB;
    border-radius: 0.2rem;
    padding: 0.2rem 0.4rem;
    user-select: none;
}

.histBtn > button:last-child {
    background-color: #FF7122;
    color: #fff;
    border-color: #FF7122;
}

.histBtn > button[disabled="disabled"]{
    pointer-events: none;
    background-color: #a3a3a3;
    border-color: #a3a3a3;
}

.warningDetails{
    font-size: 0.8rem;
    color: #ffa722;
}

.historicContainer {
    max-height: 32rem;
    overflow-y: auto;
}

summary {
    list-style: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.2rem 0.3rem;
    font-weight: bold;
}

summary::after {
    content: '';
    width: 18px;
    height: 10px;
    background: url('../../../assets/detailsArrow.svg') no-repeat;
    background-size: cover;
    transition: 0.2s;
}

details[open]>summary::after {
    transform: rotate(180deg);
}

summary::-webkit-details-marker {
    display: none;
}

summary {
    color: #30353b;
    border-radius: 5px;
}

details[open] summary {
    border-radius: 5px 5px 0 0;
}

details {
    border: 1px solid #d5dada;
    border-radius: 0.2rem;
    margin: 0.5rem 0;
}

details section>*:first-child {
    margin: 0;
}

details section>*+* {
    margin: 0.75em 0 0 0;
}

details section {
    padding: 10px;
    margin: 0;
}
</style>